/**
 * PGLP | MONTE HERMOM
 * HOOK: useTermosRegistrais
 * ------------------------------------------------------------
 * Carrega os termos registrais do backend com cache em memória.
 * - 1 requisição por sessão do navegador
 * - Compartilha cache entre todos os componentes
 * ============================================================
 */

import { useState, useEffect } from 'react';

/* Cache compartilhado em escopo de módulo */
let CACHE = null;
let CACHE_PROMISE = null;

export function useTermosRegistrais() {
  const [termos, setTermos] = useState(CACHE || []);
  const [loading, setLoading] = useState(!CACHE);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (CACHE) return;

    if (!CACHE_PROMISE) {
      CACHE_PROMISE = fetch('/api/judiciario/termos-registrais.php', {
        credentials: 'include',
      })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.json();
        })
        .then((d) => {
          if (!d.success) throw new Error(d.error || 'Falha ao carregar termos');
          CACHE = d.termos || [];
          return CACHE;
        })
        .finally(() => {
          CACHE_PROMISE = null;
        });
    }

    CACHE_PROMISE
      .then((lista) => {
        setTermos(lista);
        setErro(null);
      })
      .catch((e) => {
        console.error('[useTermosRegistrais]', e);
        setErro(e.message);
        setTermos([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return { termos, loading, erro };
}

/**
 * Limpa o cache manualmente (útil após edição no banco).
 */
export function limparCacheTermos() {
  CACHE = null;
  CACHE_PROMISE = null;
}